<template>
  <span
    v-if="label"
    class="ui-item-contents-type-icon"
  >
    <BaseIcon size="size-5" :name="icon" :alt="label" />
    <span>{{ label }}</span>
  </span>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'

const { ls } = useI18n()
const { $getCodeDigitalContentsType } = useNuxtApp()

interface Props {
  contentsType?: string
}
const props = withDefaults(defineProps<Props>(), {
})

const typeMapping = {
  'image' : 'mdi/image-size-select-actual',
  'video' : 'mdi/movie-open-play',
  'text' : 'mdi/book-open-variant',
  'sound' : 'mdi/music-box-multiple',
  'website' : 'mdi/web',
  'other' : 'mdi/file-document-multiple-outline',
}

const icon = computed((): SVG_NAMES => {
  return typeMapping[props.contentsType] as SVG_NAMES
})

const label = computed((): string => {
  return ls($getCodeDigitalContentsType().values.find(v => v.code === props.contentsType)?.value)
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-item-contents-type-icon {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: $hina-text-sub;
  fill: $hina-text-sub;
}
</style>